import styled from 'styled-components';
import Link from '@nubank/nuds-web/components/Link/Link';
import { nuDSColor, spacing } from '@nubank/nuds-web/styles/themeUtils';

export const StyledLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  padding: ${spacing('5x')};
  margin-bottom: ${spacing('6x')};
  border: 1px solid ${nuDSColor('black', 'defaultT10')};
  border-radius: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

StyledLink.displayName = 'StyledLink';
